/*  Copyright (C) 2023 OhmConnect, Inc. - All Rights Reserved  */
import React from 'react';
import {css} from 'styled-components';

export const BootstrapStyles: React.FC = () => (
  <style>{`${css`
    @import url('https://cdn.jsdelivr.net/npm/bootstrap@4.0.0/dist/css/bootstrap.min.css');
  `}`}</style>
);
